import { NgModule } from '@angular/core';
import { CommonModule, OfferCalculatorDetailsTableModule, OfferCalculatorPaymentScheduleModule, OfferDrawSliderModule } from 'common';
import { MatSliderModule } from '@angular/material/slider';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { LawCaseFinancingContentComponent } from './law-case-financing-content.component';
import { CurrencyPipe, PercentPipe } from '@angular/common';
import { ShareOfferModule } from '../share-offer/share-offer.module';
import { CalculatorClosingRequirementsModule } from '../calculator-closing-requirements/calculator-closing-requirements.module';
import { LinkYourBankModule } from '../link-your-bank/link-your-bank.module';

@NgModule({
  imports: [
    CommonModule,
    MatSliderModule,
    FlexLayoutModule,
    ShareOfferModule,
    CalculatorClosingRequirementsModule,
    LinkYourBankModule,
    OfferCalculatorDetailsTableModule,
    OfferDrawSliderModule,
    OfferCalculatorPaymentScheduleModule
  ],
  declarations: [
    LawCaseFinancingContentComponent
  ],
  exports: [
    LawCaseFinancingContentComponent
  ],
  providers: [
    PercentPipe,
    CurrencyPipe
  ]
})
export class LawCaseFinancingContentModule { }
